require([
  "jquery",
  "root/Base/Js/MbiImageSize",
  "flickity",
  "base/MbiHelper",
  "base/MbiMediaQuery",
  "wow",
  "root/Assets/Js/Ajax",
  "root/Assets/Js/HoverHandler",
  "base/MbiLazySizes",
  "root/Base/Js/Vendor/PictureFill",
  "root/Assets/Js/Templates",
  "fitty",
], function ($, mbiImageSize, Flickity, _, mbiMq) {
  ("use strict");

  mbiImageSize.init();
  var wow = "";

  // $('.js_ajax').removeClass('js_ajax');
  if (
    "lap-" in mbiMq.mqArea ||
    $("html").hasClass("touch") ||
    $("html").hasClass("ie10")
  ) {
    $(".js_ajax").removeClass("js_ajax");
    // console.log('ie?');
  } else {
    wow = new WOW({
      offset: 130,
      mobile: false,
    }).init();
    // console.log('no ie');
  }

  function initSwiper() {
    if (_.exists(".swiper")) {
      $(".swiper").each(function () {
        if ($(this).find(".slide").length > 1) {
          var $container = $(this);
          if ($(this).find(".slide").length >= 1) {
            var prvbt = false;
            var autoplay = 6000;
            var wraparo = true;
            var draga = true;
            var pagedots = true;
            var $options = {
              cellSelector: ".slide",
              pageDots: pagedots,
              wrapAround: wraparo,
              autoPlay: autoplay,
              draggable: draga,
              prevNextButtons: prvbt,
              lazyLoad: true,
              // setGallerySize: false,
              arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 60,
                y2: 42,
                x3: 18,
              },
            };
            document.ontouchmove = function (e) {
              return true;
            };
            var flktyid = "#" + $(this).attr("id");
            var flkty = new Flickity(flktyid, $options);
            // var carouselStatus = $container.find('.carousel-status');

            // function updateStatus() {
            //   var slideNumber = flkty.selectedIndex + 1;
            //   carouselStatus.html(slideNumber + '/' + flkty.slides.length);
            // }
            // updateStatus();

            // flkty.on( 'select', updateStatus );
          }
          $(this).addClass("is-visible");
        }
      });

      setTimeout(function () {
        mbiImageSize.init();
        // $('.flickity-slider').each(function(){
        //     if($(this).find('.slide').length == 0) {
        //         $(this).parents('.flickity-viewport').remove();
        //     }
        // });
      }, 100);
    }
    if (_.exists(".woocommerce-product-gallery__wrapper")) {
      $(".woocommerce-product-gallery__wrapper").each(function () {
        if ($(this).find(".woocommerce-product-gallery__image").length > 1) {
          var $container = $(this);
          if ($(this).find(".woocommerce-product-gallery__image").length >= 1) {
            var prvbt = true;
            var autoplay = 6000;
            var wraparo = true;
            var draga = true;
            var pagedots = false;
            var $options = {
              cellSelector: ".woocommerce-product-gallery__image",
              pageDots: pagedots,
              wrapAround: wraparo,
              autoPlay: autoplay,
              draggable: draga,
              prevNextButtons: prvbt,
              lazyLoad: true,
              // setGallerySize: false,
              arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 60,
                y2: 42,
                x3: 18,
              },
            };
            document.ontouchmove = function (e) {
              return true;
            };
            var flktyid = document.querySelector(
              ".woocommerce-product-gallery__wrapper"
            );
            var flkty = new Flickity(flktyid, $options);
            // var carouselStatus = $container.find('.carousel-status');

            // function updateStatus() {
            //   var slideNumber = flkty.selectedIndex + 1;
            //   carouselStatus.html(slideNumber + '/' + flkty.slides.length);
            // }
            // updateStatus();

            // flkty.on( 'select', updateStatus );
          }
          $(this).addClass("is-visible");
        }
      });

      setTimeout(function () {
        mbiImageSize.init();
        // $('.flickity-slider').each(function(){
        //     if($(this).find('.slide').length == 0) {
        //         $(this).parents('.flickity-viewport').remove();
        //     }
        // });
      }, 100);
    }
  }

  initSwiper();

  $(document).on("AjaxSwapDone", function () {
    setTimeout(function () {
      initSwiper();
      fitty(".fit", {
        minSize: 16,
        maxSize: 465,
        multiLine: true,
      });

      if (wow != "") {
        wow.sync();
      }
    }, 10);

    setTimeout(function () {
      resizeHeader();
    }, 500);
  });

  $(document).on("click", ".js_open-sub", function (e) {
    e.preventDefault();
    $(document).find(".menu__level1").removeClass("is_open");
    $(this).parent().siblings(".menu__level1").addClass("is_open");
  });

  $(document).on("focus", "#contactinput", function () {
    $(this).attr("placeholder", "");
  });

  $(document).on("blur", "#contactinput", function () {
    $(this).attr("placeholder", $(this).attr("data-placeholder"));
  });

  $(document).on("focus", ".input-email", function () {
    $(this).attr("placeholder", "");
  });

  $(document).on("blur", ".input-email", function () {
    $(this).attr("placeholder", $(this).attr("data-placeholder"));
  });

  $("body").on("click", "form.cart .plus, form.cart .minus", function () {
    // Get current quantity values
    var quantity = $(this).closest(".quantity").find(".qty");
    var val = parseFloat(quantity.val());
    var max = parseFloat(quantity.attr("max"));
    var min = parseFloat(quantity.attr("min"));
    var step = parseFloat(quantity.attr("step"));

    // Change the value if plus or minus
    if ($(this).is(".plus")) {
      if (max && max <= val) {
        quantity.val(max);
      } else {
        quantity.val(val + step);
      }
    } else {
      if (min && min >= val) {
        quantity.val(min);
      } else if (val > 1) {
        quantity.val(val - step);
      }
    }
  });

  $(document).on("click", ".js_open-about", function (e) {
    e.preventDefault();
    $(".section-about").addClass("is_open");
    $("body").addClass("is_locked");
    $("#topnav").removeClass("is_open");
  });

  $(document).on("click", ".js_close-about", function () {
    $(".section-about").removeClass("is_open");
    $("body").removeClass("is_locked");
  });

  $(document).on("click", ".js_send-contact", function () {
    var valid = $("#contactinput").val() != "";
    if (valid) {
      $(".js_send-contact").addClass("disabled");
      $.ajax({
        type: "POST",
        dataType: "json",
        data: {
          action: "sendmail",
          email: $(".input-email-contact").val(),
          text: $("#contactinput").val(),
        },
      })
        .done(function (data) {
          console.log("success");
          console.log(data);
          $("#contactinput")
            .val($("#contactinput").attr("data-thx"))
            .addClass("disabled")
            .prop("disabled", true);
          $(".js_send-contact").addClass("disabled");
          // $('.msg').html($('.msg-thx').attr('data-thx')).addClass('is-visible');
          // $('input, textarea').val('');
          // $('.inputs').addClass('is-hidden');
          // $('.button-send').addClass('is-hidden');
          // $('.button-thx').addClass('is-visible');
          // $('.js_removeWhenSend').addClass('is-hidden');
          // window.location = location + "#danke";
          // $('.site').removeClass('is-fadingout');
        })
        .fail(function () {
          // console.log("error");
        })
        .always(function () {
          // console.log("complete");
        });
    }
    // console.log('valid');
  });

  $(document).on("click", ".js_open-contact", function (e) {
    e.preventDefault();
    $(".section-contact").addClass("is_open");
    $("body").addClass("is_locked");
    $("#topnav").removeClass("is_open");
  });

  $(document).on("click", ".js_close-contact", function () {
    $(".section-contact").removeClass("is_open");
    $("body").removeClass("is_locked");
  });

  $(document).on("click", ".js_choose-product", function (e) {
    var target = $(document).find(".js_link-to-big");
    target.attr("href", $(this).attr("data-link"));
    target.removeClass("disabled");
    $(".js_choose-product").removeClass("is_active");
    $(this).addClass("is_active");
  });

  $(document).on("click", ".js_toggle-menu", function () {
    $("#topnav").toggleClass("is_open");
  });

  $(document).on("submit", "#mc-embedded-subscribe-form", function (e) {
    e.preventDefault();
    var form = $("#mc-embedded-subscribe-form");
    if (form.find("input").val() != "") {
      $.ajax({
        type: "POST",
        url: form.attr("action"),
        data: form.serialize(),
        dataType: "jsonp",
        contentType: "application/json",
        jsonpCallback: "callback",
        success: function (data) {
          if (data.result != "error") {
            $(".msg")
              .html($(".msg-thx").attr("data-thx"))
              .addClass("is-visible");
            // $('input, textarea').val('');
            // $('.inputs').addClass('is-hidden');
            // $('.button-send').addClass('is-hidden');
            // $('.button-thx').addClass('is-visible');
          } else {
            $(".msg").html(data.msg).addClass("is-visible");
          }
          $("textarea").val("");
          // $('.inputs').addClass('is-hidden');
          $(".link-subscribe").addClass("is-hidden");
          // $('.button-thx').addClass('is-visible');
        },
      });
    } else {
      $(".inputs").removeClass("is-hidden");
      $(".msg").html($(".msg-thx").attr("data-thx")).removeClass("is-visible");
      $(".button-thx").removeClass("is-visible");
      // console.log('not valid');
    }
  });

  const fitty = require("fitty");

  fitty(".fit", {
    minSize: 16,
    maxSize: 465,
    multiLine: true,
  });

  (function () {
    // no promise support (<=IE11)
    if (!("Promise" in window)) {
      return;
    }

    // called when all fonts loaded
    function redrawFitty() {
      document.documentElement.classList.add("fonts-loaded");
      fitty.fitAll();
    }

    // CSS Font Loading API
    function native() {
      // load our custom Passenger-Serif-Light font
      var fontPassenger = new FontFace(
        "Passenger-Serif-Light",
        "url(../../Assets/Fonts/PassengerSerifLight.woff2)",
        {
          style: "normal",
          weight: "400",
        }
      );
      document.fonts.add(fontPassenger);
      fontPassenger.load();

      // if all fonts loaded redraw fitty
      document.fonts.ready.then(redrawFitty);
    }

    // FontFaceObserver
    function fallback() {
      var style = document.createElement("style");
      style.textContent =
        '@font-face { font-family: "Passenger-Serif-Light"; src: url(../../Assets/Fonts/PassengerSerifLight.woff2) format("woff2");}';
      document.head.appendChild(style);

      var s = document.createElement("script");
      s.src =
        "https://cdnjs.cloudflare.com/ajax/libs/fontfaceobserver/2.0.13/fontfaceobserver.standalone.js";
      s.onload = function () {
        new FontFaceObserver("Passenger-Serif-Light").load().then(redrawFitty);
      };
      document.body.appendChild(s);
    }

    // Does the current browser support the CSS Font Loading API?
    if ("fonts" in document) {
      native();
    } else {
      fallback();
    }
  })();

  function resizeHeader() {
    $(".site").css(
      "margin-top",
      document.querySelector(".banner").offsetHeight
    );
    $("#topnav").css("top", document.querySelector(".banner").offsetHeight);
  }

  resizeHeader();

  $(window).on("resize", function () {
    resizeHeader();
  });

  window.onscroll = function () {
    isScrolled();
  };

  function isScrolled() {
    if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
      $("body").addClass("is-scrolled");
    } else {
      $("body").removeClass("is-scrolled");
    }
  }

  $("form.woocommerce-cart-form").on("click", ".plus, .minus", function () {
    // Get current quantity values
    var qty = $(this).closest(".quantity").find(".qty");
    var btnupdate = $("form.woocommerce-cart-form").find(
      'button[name="update_cart"]'
    );
    var val = parseInt(qty.val());
    var max = parseInt(qty.attr("max"));
    var min = parseInt(qty.attr("min"));
    var step = parseInt(qty.attr("step"));

    // Change the value if plus or minus
    if ($(this).is(".plus")) {
      if (max && max <= val) {
        qty.val(max);
      } else {
        qty.val(val + step);
        btnupdate.removeAttr("disabled");
      }
    } else {
      if (min && min >= val) {
        qty.val(min);
      } else if (val > 1) {
        qty.val(val - step);
        btnupdate.removeAttr("disabled");
      }
    }
    qty.change();
  });
});

define("Assets/Js/Footer.js", function(){});

